import { render } from "./DataTablePriceRange.vue?vue&type=template&id=15f11b26"
import script from "./DataTablePriceRange.vue?vue&type=script&lang=js"
export * from "./DataTablePriceRange.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataTableCustom/DataTablePriceRange.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15f11b26"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15f11b26', __exports__)) {
    console.log('reload')
    api.reload('15f11b26', __exports__)
  }
  
  module.hot.accept("./DataTablePriceRange.vue?vue&type=template&id=15f11b26", () => {
    console.log('re-render')
    api.rerender('15f11b26', render)
  })

}


export default __exports__